import styled from 'styled-components'
import { mq } from '../../styles/vars/media-queries.style'
import { Label } from '../../styles/vars/textStyles.style'

export const AmenitiesMain = styled.div`
  ${Label} {
    font-weight: 400;
    opacity: 0.5;
    text-transform: none;
  }
`

export const AmenitiesList = styled.ul`
  overflow: hidden;
  margin-top: 6rem;
  list-style-type: none;

  ${mq.tabletL} {
    align-content: center;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    height: 100%;
    margin-top: 0;
  }
`
